export default "__VITE_ASSET__359fd986__"